.card {
    cursor: pointer;
    width: 100%;
    display: flex;
}

.content {
    display: flex;
    flex-direction: column;
    gap: var(--exo-spacing-x-small);
    color: var(--exo-color-font);
}

.topRow {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.iconWrap {
    width: 44px;
    height: 44px;
    border-radius: var(--exo-radius-large);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

:global(.ex-theme-dark) .iconWrap {
    background: #f0f0f0;
    border: 1px solid rgba(0, 0, 0, 0.06);
}

.enabledDot {
    color: var(--exo-color-background-success-strong);
    background: var(--exo-color-background-success);
    border-radius: var(--exo-radius-circle);
}

.disabledDot {
    color: var(--exo-color-border-secondary);
}

.configName {
    font-size: var(--exo-font-size-x-small);
    font-weight: var(--exo-font-weight-semi-bold);
    line-height: 1.3;
    overflow: hidden;
    text-wrap-mode: nowrap;
    text-overflow: ellipsis;
}

.name {
    font-size: var(--exo-font-size-x-small);
    font-weight: var(--exo-font-weight-semi-bold);
    line-height: 1.3;
    word-break: break-word;
}

.idp {
    font-size: var(--exo-font-size-micro);
    color: var(--exo-color-font-secondary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
